import { createElement, lazy } from "react";
import { Redirect } from "react-router-dom";

const PublicRequestInitialView = lazy(() => import("views/Request/Home"));

export default function getRoutes(parent = "", error404) {
  const publicStepRoutes = [
    "simulator",
    "simulator_results",
    "customer",
    "documentation",
    "finish",
    "identity",
    "processing",
    "relationships",
    "credit_history_check",
    "credit_history_check_autorization",
  ];

  return [
    {
      exact: true,
      path: `${parent}`,
      component: () =>
        createElement(Redirect, {
          to: `${parent}/customer`,
        }),
    },
    ...publicStepRoutes.map((step) => ({
      exact: true,
      path: `${parent}/${step}`,
      component:
        step === "customer"
          ? PublicRequestInitialView
          : () =>
            createElement(Redirect, {
              to: `${parent}/customer`,
            }),
    })),
    error404,
  ];
}
